import React from 'react';
import { heroContent, binImages } from '../data/mock';
import { Button } from './ui/button';
import { ChevronDown, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={binImages.industrial}
          alt="Renewed Environmental Bin"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/95 via-[#1a365d]/85 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <span className="inline-block text-blue-300 font-semibold tracking-wider uppercase text-sm">
                Trusted Across Ontario
              </span>
              <h1 className="text-white">
                <span className="block text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
                  {heroContent.headline}
                </span>
                <span className="block text-5xl sm:text-6xl lg:text-7xl font-extrabold text-blue-400 mt-2">
                  {heroContent.subheadline}
                </span>
              </h1>
            </div>
            
            <p className="text-white/80 text-lg sm:text-xl max-w-xl leading-relaxed">
              {heroContent.description}
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4">
              <Button
                onClick={() => scrollToSection('#bins')}
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold text-lg px-8 py-6 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg shadow-blue-500/30"
              >
                {heroContent.cta}
              </Button>
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center space-x-2 text-white hover:text-blue-300 font-medium text-lg transition-colors py-3"
              >
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center">
                  <Phone className="h-5 w-5" />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm text-white/60">Call us anytime</span>
                  <span>{companyInfo.phone}</span>
                </div>
              </a>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center space-x-2 text-white/70">
                <div className="w-2 h-2 rounded-full bg-green-400"></div>
                <span className="text-sm">Bin Rentals</span>
              </div>
              <div className="flex items-center space-x-2 text-white/70">
                <div className="w-2 h-2 rounded-full bg-green-400"></div>
                <span className="text-sm">Waste Management</span>
              </div>
              <div className="flex items-center space-x-2 text-white/70">
                <div className="w-2 h-2 rounded-full bg-green-400"></div>
                <span className="text-sm">Remediation</span>
              </div>
              <div className="flex items-center space-x-2 text-white/70">
                <div className="w-2 h-2 rounded-full bg-green-400"></div>
                <span className="text-sm">Hydrovac</span>
              </div>
            </div>
          </div>

          {/* Right - Stats Card (hidden on mobile) */}
          <div className="hidden lg:block">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
              <h3 className="text-white text-xl font-semibold mb-6">Why Customers Choose Us</h3>
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="text-4xl font-bold text-blue-400">6</div>
                  <div className="text-white/70">Core service offerings</div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="text-4xl font-bold text-blue-400">10+</div>
                  <div className="text-white/70">Years serving Ontario</div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="text-4xl font-bold text-blue-400">24/7</div>
                  <div className="text-white/70">Emergency response available</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer animate-bounce"
        onClick={() => scrollToSection('#about')}
      >
        <ChevronDown className="h-10 w-10 text-white/60" />
      </div>
    </section>
  );
};

export default Hero;
